var map = {
	"./1.jpg": 80900,
	"./10.png": 32290,
	"./11.jpg": 49507,
	"./11.png": 53419,
	"./2.jpg": 80947,
	"./3.png": 60466,
	"./4.jpg": 66205,
	"./5.jpg": 40640,
	"./6.jpg": 23631,
	"./7.jpg": 47250,
	"./8.jpg": 18057,
	"./9.png": 65416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88019;